import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import config from '../../../../../config/config';
import { CentroSeleccionado, RUTAS_API_POR_CENTRO } from '../models/centro-seleccionado';
import { SeleccionCentroService } from '../services/seleccion-centro.service';

const URLS_POR_CENTRO = RUTAS_API_POR_CENTRO.map((ruta) => config.URL_API_ISO45001 + ruta);

function esDeVigilancia(url: string): boolean {
  return URLS_POR_CENTRO.some((base) => url === base || url.startsWith(base + '/') || url.startsWith(base + '?'));
}

/**
 * La petición con la empresa y el centro elegidos (`?int_empresa_id=&int_centro_id=`) si va a la API de
 * vigilancia de la salud; cualquier otra, o sin centro elegido, tal cual.
 */
export function conCentroSeleccionado<T>(req: HttpRequest<T>, seleccion: CentroSeleccionado | null): HttpRequest<T> {
  if (!seleccion || !esDeVigilancia(req.url)) return req;
  return req.clone({
    setParams: {
      int_empresa_id: String(seleccion.int_empresa_id),
      int_centro_id: String(seleccion.int_centro_id),
    }
  });
}

/** Todas las peticiones del módulo llevan el centro elegido, también las que abren una ficha por su id. */
export const centroSeleccionadoInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) =>
  next(conCentroSeleccionado(req, inject(SeleccionCentroService).actual));
